import { Box } from "@mui/material";
import { ReactNode, useMemo, useRef } from "react";
import useElementSize from "@arelia-hooks/useElementSize";
import { CONSTANTS } from "@arelia-utils/constants/constants";
import calcRowHeight from "@arelia-utils/helpers/calcRowHeight";

export function GridLayout({ children, customColumns = `repeat(${CONSTANTS.GRID_LAYOUT.COLUMNS}, 1fr)`, customRows }: { children: ReactNode, customColumns?: string, customRows?: number }) {
  const gridRef = useRef<HTMLDivElement>(null);
  const { width: gridWidth } = useElementSize(gridRef);
  const rowHeight = useMemo(() => calcRowHeight(gridWidth), [gridWidth]);

  return <Box
    display="grid"
    gridTemplateColumns={customColumns}
    gridTemplateRows={customRows ? `repeat(${customRows}, 1fr)` : undefined}
    gridAutoRows={`minmax(${CONSTANTS.GRID_LAYOUT.MIN_ROW_HEIGHT}px, ${rowHeight}px)`}
    gap={`${CONSTANTS.GRID_LAYOUT.GAP}px`}
    gridAutoFlow="dense"
    ref={gridRef}
  >
    {children}
  </Box>
}